import * as p from '@clack/prompts'
import pc from 'picocolors'

export function printAdminReadyNote(state: {
  adminLoginUrl: string
  adminEmail?: string
  adminPassword?: string
}): void {
  const lines = [`Admin: ${pc.cyan(state.adminLoginUrl)}`]

  // Intentional one-time credentials display: this note renders once at the
  // end of the interactive init flow so the user can log in immediately.
  if (state.adminEmail && state.adminPassword) {
    lines.unshift(`Password: ${pc.cyan(state.adminPassword)}`)
    lines.unshift(`Admin user: ${pc.cyan(state.adminEmail)}`)
  } else if (state.adminEmail) {
    lines.unshift(`Admin user: ${pc.cyan(state.adminEmail)}`)
  }

  p.note(lines.join('\n'), 'Admin ready')
}
